<template>
  <div class="page-wrapper">
    <div class="promote-summary">
      <div class="content">
        <h4>Promote to {{ capitalizedNextEnvironment }} Summary</h4>
        <div class="clients">
          <h6>
            The following clients will be promoted to {{ nextEnvironment }}:
          </h6>
          <v-chip-group v-for="client in promoteClients" :key="client.clientId">
            <tag close @click:close="removeClient(client.clientId)">{{
              client.clientId
            }}</tag>
          </v-chip-group>
        </div>
      </div>
    </div>
    <bottomBar>
      <qvoButton text @click="cancel">Cancel</qvoButton>
      <qvoButton @click="promoteConfirmation"
        >Promote To {{ capitalizedNextEnvironment }}</qvoButton
      >
    </bottomBar>
    <promoteConfirmation
      v-model="showConfirmation"
      @closeModal="closeConfirmation"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import capitalize from "lodash/capitalize";

import bottomBar from "@/components/bottom-bar";
import tag from "@/qux-common/qux22/components/molecules/tag";
import qvoButton from "@/qux-common/qux22/components/molecules/button";

import promoteConfirmation from "./promote-confirmation";

export default {
  name: "PromoteSummary",
  components: {
    bottomBar,
    tag,
    qvoButton,
    promoteConfirmation,
  },
  data() {
    return {
      showConfirmation: false,
    };
  },
  computed: {
    capitalizedNextEnvironment() {
      return capitalize(this.nextEnvironment);
    },
    ...mapGetters({
      promoteClients: "getPromoteClients",
      nextEnvironment: "getNextEnvironment",
    }),
  },
  methods: {
    removeClient(ClientId) {
      this.$store.dispatch("removePromoteClient", {
        ClientId,
      });
    },
    cancel() {
      this.$router.push("/clients");
    },
    promoteConfirmation() {
      this.showConfirmation = true;
    },
    closeConfirmation() {
      this.showConfirmation = false;
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.page-wrapper {
  height: calc(100vh - $header-height);
}
.promote-summary {
  height: calc(100% - 74px);
  overflow: auto;
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
  h4 {
    padding-bottom: 12px;
  }
  .clients {
    margin-top: $qvo-spacing-24;
    border: 2px solid $qvo-color-blue-400;
    border-radius: 8px;
    padding: $qvo-spacing-24;
  }
}
</style>